import type { FC, ReactNode } from "react";
import { Header, Heading } from "react-aria-components";
import { tv } from "tailwind-variants";
import { ModalCloseButton } from "./modalCloseButton.js";

export interface ModalHeaderProps {
  children: ReactNode;
  isCloseVisible?: boolean;
  /** @deprecated Use `isCloseVisible` instead. No explicit event handler implementation is needed. */
  onClose?: () => void;
}

export const modalHeader = tv({
  slots: {
    header: "flex items-center justify-between space-x-4",
    title: "text-xl leading-5 font-semibold text-foreground",
  },
});

export const ModalHeader: FC<ModalHeaderProps> = (props) => {
  return (
    <Header className={modalHeader().header()}>
      <Heading
        slot="title"
        className={modalHeader().title({ className: "leading-6" })}
      >
        {props.children}
      </Heading>

      {props.isCloseVisible || props.onClose ? (
        <ModalCloseButton onPress={props.onClose} />
      ) : null}
    </Header>
  );
};
